module.exports = __webpack_public_path__ + "img/betterware.6422e410.png";